if (!customElements.get('fpt-slider')) {
  customElements.define(
    'fpt-slider',
    class FptSlider extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector('.fpt-swiper');
        this.bullets = Array.from(this.querySelectorAll('.fpt-bullet'));
        this.bulletsContainer = this.querySelector('.fpt-bullets-nums');
        this.dynamicBullets = this.dataset.dynamicBullets === 'true';
        this.prevBtn = this.querySelector('.fpt-btn-prev');
        this.nextBtn = this.querySelector('.fpt-btn-next');

        if (!this.swiperEl) return;

        if (window.FoxTheme && window.FoxTheme.Carousel) {
          this.initSwiper();
        } else {
          window.addEventListener('load', () => this.initSwiper(), { once: true });
        }

        const tabsEl = this.closest('product-tabs') || this.closest('tabs-component');
        if (tabsEl) {
          tabsEl.addEventListener('tabChange', () => {
            const panel = this.closest('[role="tabpanel"]');
            if (panel && !panel.hidden && this.carousel) {
              setTimeout(() => {
                this.carousel.slider.update();
                if (this.dynamicBullets) {
                  this.rebuildBullets();
                } else {
                  this.updateProgress(this.carousel.slider.activeIndex);
                }
              }, 350);
            }
          });
        }
      }

      initSwiper() {
        var self = this;

        var ds = this.dataset;
        var num = function(v, d) {
          var n = parseFloat(v);
          return isNaN(n) ? d : n;
        };

        // Per-section overrides via data attributes (fallback keeps default behavior)
        var group = num(ds.slidesGroup, 2);
        var breakpoints = {
          640: { slidesPerView: num(ds.slidesSm, 2), spaceBetween: num(ds.gapSm, 16), slidesPerGroup: group },
          1024: { slidesPerView: num(ds.slidesDesktop, 4), spaceBetween: num(ds.gapDesktop, 20), slidesPerGroup: group },
        };
        if (ds.slidesTablet) {
          breakpoints[768] = { slidesPerView: num(ds.slidesTablet, 3), spaceBetween: num(ds.gapTablet, 16), slidesPerGroup: group };
        }

        this.carousel = new window.FoxTheme.Carousel(this.swiperEl, {
          slidesPerView: num(ds.slidesMobile, 1),
          slidesPerGroup: group,
          spaceBetween: num(ds.gapMobile, 12),
          threshold: 2,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: this.nextBtn,
            prevEl: this.prevBtn,
          },
          breakpoints: breakpoints,
        });

        this.carousel.init();

        this.progressFill = this.querySelector('.fpt-progress__fill');

        this.carousel.slider.on('slideChange', function() {
          self.updateProgress(self.carousel.slider.activeIndex);
        });

        if (this.dynamicBullets) {
          this.rebuildBullets();
          this.carousel.slider.on('resize', function() { self.rebuildBullets(); });
          this.carousel.slider.on('breakpoint', function() { self.rebuildBullets(); });
        } else {
          this.bindBullets();
        }

        this.updateProgress(0);
      }

      bindBullets() {
        var self = this;
        this.bullets.forEach(function(bullet, i) {
          bullet.addEventListener('click', function() {
            if (self.dynamicBullets) {
              self.goToSnap(i);
            } else {
              self.carousel.slider.slideTo(i * (self.carousel.slider.params.slidesPerGroup || 1));
            }
          });
        });
      }

      goToSnap(i) {
        var slider = this.carousel && this.carousel.slider;
        if (!slider || !slider.snapGrid) return;
        var target = slider.snapGrid[i];
        if (target == null) return;
        var slideIndex = 0;
        var best = Infinity;
        (slider.slidesGrid || []).forEach(function(v, idx) {
          var d = Math.abs(v - target);
          if (d < best) { best = d; slideIndex = idx; }
        });
        slider.slideTo(slideIndex);
      }

      // Rebuild the "01 02 …" bullets to match the slider's actual snap
      // positions for the current breakpoint (so the count is always correct).
      rebuildBullets() {
        if (!this.bulletsContainer) return;
        var slider = this.carousel && this.carousel.slider;
        if (!slider) return;
        var count = (slider.snapGrid && slider.snapGrid.length) || 1;
        if (count < 1) count = 1;

        var html = '';
        for (var i = 0; i < count; i++) {
          var n = ('0' + (i + 1)).slice(-2);
          html += '<button class="fpt-bullet' + (i === 0 ? ' fpt-bullet--active' : '') +
            '" type="button" aria-label="Slide ' + (i + 1) + '"><span class="fpt-bullet__num">' + n + '</span></button>';
        }
        this.bulletsContainer.innerHTML = html;
        this.bullets = Array.prototype.slice.call(this.bulletsContainer.querySelectorAll('.fpt-bullet'));
        this.bindBullets();
        this.updateProgress(slider.activeIndex);
      }

      updateProgress(activeIndex) {
        var total = this.bullets.length;
        if (!total) return;

        // Derive the active page from the slider's overall progress (0 → 1).
        // This stays correct even when the slider can only advance a fraction
        // of a group near the end (e.g. 3 of 4 slides visible on desktop),
        // where floor(activeIndex / group) would otherwise get stuck.
        var slider = this.carousel && this.carousel.slider;
        var pageIndex;
        if (this.dynamicBullets && slider && typeof slider.snapIndex === 'number') {
          pageIndex = Math.min(Math.max(slider.snapIndex, 0), total - 1);
        } else if (slider && typeof slider.progress === 'number') {
          var progress = Math.min(1, Math.max(0, slider.progress));
          pageIndex = Math.round(progress * (total - 1));
        } else {
          var group = (slider && slider.params.slidesPerGroup) || 1;
          pageIndex = Math.min(Math.floor(activeIndex / group), total - 1);
        }

        this.bullets.forEach(function(bullet, i) {
          bullet.classList.toggle('fpt-bullet--active', i === pageIndex);
        });

        if (!this.progressFill) return;

        var activeBullet = this.bullets[pageIndex];
        var barEl = this.progressFill.parentElement;
        var barRect = barEl.getBoundingClientRect();
        var fillPct;

        if (pageIndex === total - 1) {
          fillPct = 100;
        } else if (barRect.width > 0) {
          var bulletRect = activeBullet.getBoundingClientRect();
          var bulletRight = bulletRect.right - barRect.left;
          fillPct = Math.min(100, Math.max(0, (bulletRight / barRect.width) * 100));
        } else {
          fillPct = ((pageIndex + 1) / total) * 100;
        }

        this.progressFill.style.width = fillPct + '%';
      }
    }
  );
}
